import React from "react";
import { default as WFormHelperText } from "@mui/material/FormHelperText";

function FormHelperText(props) {
  return <WFormHelperText {...props} />;
}

export default FormHelperText;
